<template>
  <div class="agreement_page">
    <div class="agreement_title">{{info.title}}</div>
    <div class="agreement_content" v-html="info.content"></div>
  </div>
</template>

<script>
  import content from '../../api/content';
  export default {
    data () {
      return {
        info:'',
      }
    },
    created () {
      this.getAgreement(4)
      this.$store.commit('param/show', false)
    // his.name = '凌志范儿'
    this.$appService.isShowReturn({state: true})
    
  },
  methods: {
    getAgreement(id){
      content.getAgreement({id:id}).then(res => {
        this.info=res.data.data
      })
    },
  }
};
</script>

<style lang="scss">
  .agreement_page {
    padding: 10px;
  }
</style>
